import React from 'react';
import { Box, SimpleGrid, Skeleton, SkeletonText} from '@chakra-ui/react';

const OneCardSkeleton = () => {
  return (
    <main>
    
      
        <Box w={{ base: '100%'}}>
         

          <SimpleGrid columns={[1]} spacing={4} mt={5} width={['100%']}>
            
            {Array.from({ length: 1 }).map((_, index) => (
              <Box key={index} display="flex" flexDirection="row" gap={4} p={4} borderWidth="1px" borderRadius="xl" boxShadow="md">
                
                <Box flex="1">
                  <Skeleton height="20px" width="70%" />
                  <SkeletonText mt="4" noOfLines={2} spacing="4" />
                  <Skeleton height="20px" width="50%" mt={2} />
                </Box>
              </Box>
            ))}
          </SimpleGrid>
        </Box>

      

      
    </main>
  );
};

export default OneCardSkeleton;
